import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import { Submission, SubmissionMethod } from '../_models/submission';
import { SUBMISSION_MSGS, FILE_UPLOAD_CONFIG, PRODUCT_CONFIG } from 'src/app/_common/product-config';
import { NgForm } from '@angular/forms';
import { SubmissionsService } from '../_services/submissions.service';
import { DocumentFileType } from 'src/app/_common/_enum/module.enum';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-submission-attachments',
  templateUrl: './submission-attachments.component.html',
  styleUrls: ['./submission-attachments.component.scss']
})
export class SubmissionAttachmentsComponent implements OnInit {

  private submissionAttachments: Submission;
  private submissionData;
  private submissionMethod: SubmissionMethod = new SubmissionMethod();
  
  private loading:boolean = false;
  
  private submissionMsgs = SUBMISSION_MSGS; //Using it in HTML
  private documentFileTypeEnum = DocumentFileType; // Using it in HTML
  private fileUploadConfig = FILE_UPLOAD_CONFIG; // Using it in HTML
  private productConfig = PRODUCT_CONFIG;
  
  private uploadedFileSize: number = 0;
  private attachmentError: string = null;
  private supportingDocuments = [];

  private isSubmitted:boolean = false;
  private isSubmittedByMe:boolean = true;

  @Input() isNewSubmission: boolean = true;
  @Output() attachFileSize = new EventEmitter<any>();

  @ViewChild("attachmentsForm", {static: false}) attachments: NgForm;
  constructor(private submissionService: SubmissionsService, private commonService: CommonService, private el: ElementRef) { }

  ngOnInit() {
    this.submissionAttachments = this.getSubmission();
    this.submissionData = this.submissionAttachments.submissionData;
    let loggedInProfile = this.submissionService.getLoggedInProfile();

    this.isSubmittedByMe = (loggedInProfile.email == this.submissionData.submittedEmail);

    this.supportingDocuments = this.submissionService.getSupportingDocuments();
    this.uploadedFileSize = 0;
    this.supportingDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.attachFileSize.emit(this.uploadedFileSize);
  }

  getSubmission(){
    return this.submissionService.submission;
  }

  getSelectedDocuments(){
    let docFiles = this.submissionService.getSupportingDocuments();

    return docFiles;
  }

  getUploadedDocuments(){
    //keep this code : this.submissionService.submission.submissionData. When we upload from Details, we need to show it here very next second.
    let docFiles = this.submissionService.submission.submissionData.attachments;

    return docFiles;
  }

  setFileIcon(file: any){
    return this.commonService.setFileIcon(file);
  }

  fileBrowseHandler(files) {
    //this.prepareFilesList(_files);
    this.uploadAllDocuments(files);
  }

  uploadAllDocuments(files, _documentType=this.documentFileTypeEnum.InsuranceApplication){
    if(files.currentTarget && files.currentTarget.files){
      files = files.currentTarget.files;
    }

    if (files.length == 0) {
      console.log("No file selected!");
      return;
    }

    console.log(_documentType);
    let allDocuments = this.submissionService.getSupportingDocuments();
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.attachmentError = null;

    Array.from(files).forEach((_file:any)=>{
      _file.documentType = _documentType;
      _file.uniqueName = (Math.random() * 1000000000).toFixed(0);
      if(_file.size>0 && (this.uploadedFileSize+(Number(_file.size)))<this.fileUploadConfig.MaxUploadSize){
        this.uploadedFileSize+=(Number(_file.size));
        this.submissionService.addSupportingDocument(_file);  
      }else if(_file.size == 0){
        this.attachmentError = this.fileUploadConfig.AttachmentNoContent;
        console.log("File has no content");
      }else{
        this.attachmentError = this.fileUploadConfig.AttachmentExceeds;
        console.log("File size exceeding");
      }
    });
    
    this.attachFileSize.emit(this.uploadedFileSize);
    this.supportingDocuments = this.submissionService.getSupportingDocuments();
  }

  removeDocument(_uniqueName){
    let allDocuments = this.submissionService.getSupportingDocuments();
    let fileIndex = allDocuments.findIndex(_docFile=>{return _docFile.uniqueName == _uniqueName});
    this.submissionService.getSupportingDocuments().splice(fileIndex, 1);
    
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.attachFileSize.emit(this.uploadedFileSize);
    if(this.uploadedFileSize < this.fileUploadConfig.MaxUploadSize){
      this.attachmentError = null;
    }
  }

  get isFormValid(): boolean{
    return (this.supportingDocuments.length > 0 || (this.submissionData && this.submissionData.attachments.length > 0));
  }

  onContinue():boolean{
    this.isSubmitted = true;
    if(this.isFormValid == false){ this.attachmentError = this.submissionMsgs.DocumentsRequired }
    console.log(this.submissionAttachments);
    return this.isFormValid;
  }
}
